import { Tag, Tooltip } from 'antd'
import { menuBuilderSharedMissingIngredientsCopy as copy } from 'src/constants/menuBuilderCopy'

const SharedMissingIngredientsListBadge = ({
  missingSharedIngredients = [],
}) => {
  const tooltip = (
    <div style={{ maxWidth: 260, lineHeight: 1.4 }}>
      <div style={{ marginBottom: 8 }}>{copy.listBadgeTooltip}</div>
      {missingSharedIngredients?.length ? (
        <>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>
            Missing ingredients:
          </div>
          <ul style={{ paddingLeft: 16, margin: 0 }}>
            {missingSharedIngredients.map((ing, idx) => (
              <li key={`${ing?.title || 'unknown'}-${ing?.sku || ''}-${idx}`}>
                {ing?.title || 'Unknown'}
                {ing?.sku ? ` (SKU: ${ing.sku})` : ''}
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  )

  return (
    <Tooltip title={tooltip}>
      <Tag
        style={{
          backgroundColor: '#fff2e8',
          borderColor: '#ffb366',
          color: '#d46b08',
          fontSize: '10px',
          lineHeight: '18px',
          margin: 0,
          fontWeight: 600,
        }}
      >
        ⚠ {copy.listBadgeLabel}
      </Tag>
    </Tooltip>
  )
}

export default SharedMissingIngredientsListBadge
